module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PnWPvQ/tc-custom/9781638298861.jpg?1718183001603",
      "alt": "This image is the cover for the book The Adventures Of Finnigan"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Adventures Of Finnigan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm 0cm 8pt",
      "font-size": "15px",
      "font-family": "Calibri, sans-serif",
      "text-align": "justify"
    }
  }, [_c('em', [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("The Adventures of Finnigan")])]), _c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v(" is a fictional story about a stray cat who finds a caring family to adopt her. She tries to do the right thing and fit in with the family but is not always successful")]), _c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v(" – s")]), _c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("ometimes with humorous results.")]), _c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "background": "white"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("Her new family looks after her and forgives her when she misbehaves.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sandra McGregor\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "#252525"
    }
  }, [_vm._v("Sandra currently lives in Toronto, Ontario, Canada. She was a systems analyst prior to her career as an author.")])]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\", serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "#252525"
    }
  }, [_vm._v("Pets were important to Sandra and her sisters, and they had a cat and a dog in their family while growing up in Bowmanville.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Asutin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0